import { Component, OnInit, ViewChild } from '@angular/core';
import { Chart, registerables, } from 'chart.js';
import { Title } from "@angular/platform-browser";
import { Router } from '@angular/router';
import { IonSelect } from '@ionic/angular';

@Component({
	selector: 'app-escrow-gen2',
	templateUrl: './escrow-gen2.page.html',
	styleUrls: ['./escrow-gen2.page.scss'],
})
export class EscrowGen2Page implements OnInit {

	@ViewChild('selectElement') selectElement: IonSelect;

	coins = [
		{
			id: 1,
			name: 'Escrow GEN 1'
		},
		{
			id: 2,
			name: 'Escrow GEN 2'
		},
	];

	selectedOption = this.coins[1].id;
  
	ngAfterViewInit() {
	  this.selectElement.value = this.selectedOption;
	}

	public escrow2Chart: any;
	spinner = true;
	//balances: any;
	private escrowDataBar: any;
	tooltipLine: any;
	//dash: any; // Single Smooth line with Dash segments (p-1)

	// Getting Current Date
	today = this.getCurrentWeek();
	year = this.today.getFullYear().toString().slice(-2);
	month = (this.today.getMonth() + 1).toString().padStart(2, "0");
	day = this.today.getDate().toString().padStart(2, "0");
	currentDate = this.day + '/' + this.month + '/' + this.year;

	clickEscrowBarChartLabel: any = this.currentDate;
	clickEscrowBarChartValue: any;
	indexOfCurrentWeek: any;

	totalGen2Value = 3333333;
	gen2DivisibleValue = 66666;

	constructor(private router: Router, private titleService: Title) {
		Chart.register(...registerables);
		this.titleService.setTitle("DecentralRealty - Escrow GEN 2");
	}

	handleChange(ev) {
		if (ev.detail.value == 1) {
			this.router.navigateByUrl('/escrow');
		}
	}

	compareFn(item1: any, item2: any): boolean {
		return item1 === item2;
	}

	getCurrentWeek() {
		let cDate = new Date();
		while (cDate.getDay() != 0) {
			cDate.setDate(cDate.getDate() + 1);
		}
		return cDate;
	}

	// Function for comparing date (Start Date with Current Week Date)
	isSameDay(startDate, currentDate) {
		return startDate.getFullYear() === currentDate.getFullYear() &&
			startDate.getDate() === currentDate.getDate() &&
			startDate.getMonth() === currentDate.getMonth();
	}

	// Dynamic the data all 51 values 
	getDataset(totalGen2Value, gen2DivisibleValue) {
		let data = [];
		let label = [];
		let startDate = new Date('02/05/23');
		let currentWeek = this.getCurrentWeek();

		for (var i = 0; i <= 50; i++) {

			let value = totalGen2Value - (gen2DivisibleValue * i);
			data.push(value);
			label.push(startDate);

			if (this.isSameDay(startDate, currentWeek)) {
				this.indexOfCurrentWeek = i;
				this.clickEscrowBarChartValue = value;
			}
			startDate.setDate(startDate.getDate() + 7);
		}
		data[data.length - 1] = 0;
		return data;
	}

	// Line background color to show two colors (P-1)
	lineChartTwoColors(ctx, chartArea, scales) {
		const gradientBg = ctx.createLinearGradient(chartArea.left, 0, chartArea.right, 0)
		//const percentage = ((scales.x.getPixelForTick(2) - chartArea.left) / chartArea.width);
		const percentage = (this.indexOfCurrentWeek * 0.02);
		gradientBg.addColorStop(0, 'rgba(237, 19, 93, 0.7)');
		gradientBg.addColorStop(percentage, 'rgba(237, 19, 93, 0.7)');
		gradientBg.addColorStop(percentage, 'rgba(7, 37, 68, 0.7)');
		gradientBg.addColorStop(1, 'rgba(7, 37, 68, 0.7)');
		return gradientBg;
	}

	// Click on point to show more details in a table
	clickOnEscrowChartBar(click) {
		const barPoints = this.escrow2Chart.getElementsAtEventForMode(click, 'nearest', {
			intersect: true
		}, true);

		if (barPoints[0]) {
			const datasetIndex = barPoints[0].datasetIndex;
			const clickedBarIndex = barPoints[0].index;
			this.clickEscrowBarChartLabel = this.escrow2Chart.data.labels[clickedBarIndex];
			this.clickEscrowBarChartValue = this.escrow2Chart.data.datasets[datasetIndex].data[clickedBarIndex];
		}
	}

	private initializedChartData() {

		let labels = ['05/02/23', '12/02/23', '19/02/23', '26/02/23', '05/03/23', '12/03/23', '19/03/23', '26/03/23', '02/04/23',
			'09/04/23', '16/04/23', '23/04/23', '30/04/23', '07/05/23', '14/05/23', '21/05/23', '28/05/23', '04/06/23', '11/06/23',
			'18/06/2023', '25/06/23', '02/07/23', '09/07/23', '16/07/23', '23/07/23', '30/07/23', '06/08/23', '13/08/23', '20/08/23',
			'27/08/23', '03/09/23', '10/09/23', '17/09/23', '24/09/23', '01/10/23', '08/10/23', '15/10/23', '22/10/23', '29/10/23',
			'05/11/23', '12/11/23', '19/11/23', '26/11/23', '03/12/23', '10/12/23', '17/12/23', '24/12/23', '31/12/23', '7/01/24', '14/01/24',
			'21/01/24'];
		// Single Smooth line with Dash segments (P-2)
		//this.dash = (ctx, value) => ctx.p0DataIndex < labels.indexOf('13/3/2023') ? value : [50,0];

		let escrowDataBar = {
			labels: labels,
			borderWidth: 2,
			datasets: [
				{
					label: ' Balance ',
					data: this.getDataset(this.totalGen2Value, this.gen2DivisibleValue),
					borderColor: "#ffffff",
					backgroundColor: context => { // Line background color to show two colors (P-2)
						const chart = context.chart;
						const { ctx, chartArea, scales } = chart;
						if (!chartArea) {
							return null;
						}
						return this.lineChartTwoColors(ctx, chartArea, scales);
					},
					borderWidth: 3,
					borderRadius: 3,
					borderSkipped: false,
					tension: 0.4,
					pointHoverBorderColor: 'rgba(255, 255, 255, 1)',
					pointHoverBackgroundColor: 'rgba(255, 255, 255, 1)',
					pointBorderWidth: 0,
					pointHoverBorderWidth: 0,
					pointRadius: 3,
					pointHoverRadius: 3,
					// segment: { //Single Smooth line with Dash segments (P-3)
					// 	borderDash: ctx => this.dash(ctx, [10,10]) || [50, 0],
					// },
					fill: true
				}
			]
		};
		this.escrowDataBar = escrowDataBar;

		// Code for Showing vertical line with tooltip hovering (P-1)
		this.tooltipLine = {
			id: 'tooltipLine',
			beforeDraw: chart => {
				if (chart.tooltip._active && chart.tooltip._active.length) {
					const ctx = chart.ctx;
					ctx.save();
					const activePoint = chart.tooltip._active[0];

					ctx.beginPath();
					ctx.setLineDash([5, 7]);
					ctx.moveTo(activePoint.element.x, chart.chartArea.top);
					ctx.lineTo(activePoint.element.x, activePoint.element.y);
					ctx.lineWidth = 3;
					ctx.strokeStyle = 'rgba(255, 255, 255, 1)';
					ctx.stroke();
					ctx.restore();

					ctx.beginPath();
					ctx.moveTo(activePoint.element.x, activePoint.element.y);
					ctx.lineTo(activePoint.element.x, chart.chartArea.bottom);
					ctx.lineWidth = 3;
					ctx.strokeStyle = 'rgba(255, 255, 255, 1)';
					ctx.stroke();
					ctx.restore();
				}
			}
		}
	}

	private createEscrowBarChart() {
		this.escrow2Chart = new Chart("Escrow2BarChart", {
			type: 'line',
			data: this.escrowDataBar,
			options: {
				aspectRatio: 1,
				responsive: true,
				scales: {
					y: {
						ticks: {
							color: '#8fe5ff',
							callback: function (value) {
								if (Number(value) >= 1000000000) {
									return (Number(value) / 1000000000).toFixed(1) + 'B';
								} else if (Number(value) >= 1000000) {
									return (Number(value) / 1000000).toFixed(1) + 'M';
								}
								else if (Number(value) >= 1000) {
									return (Number(value) / 1000000).toFixed(1) + 'M';
								}
								else {
									return value;
								}
							}
						},
						grid: { color: 'rgba(255,255,255,0.3)' },
					},
					x: {
						ticks: { color: '#8fe5ff' },
						grid: { color: 'rgba(255,255,255,0.3)' },
					},

				},
				plugins: {
					legend: {
						display: false,
						position: 'bottom',
						labels: {
							padding: 15,
							color: "#ffffff"
						}
					},
					title: {
						display: true,
						color: "#ffffff",
						//text: 'Distribution Trends',
						font: {
							size: 22
						},
						padding: {
							bottom: 20
						}
					},
					// tooltip: {
					// 	callbacks: {
					// 		afterBody: function () {
					// 			return "Click for more Details";
					// 		}
					// 	}
					// }
				}
			},
			//Showing vertical line with tooltip hovering (P-2)
			plugins: [this.tooltipLine]
		});
	}

	ngOnInit(): void {
		this.spinner = false;
		//this.balances = result['balances'];
		this.initializedChartData();
		this.createEscrowBarChart();
	}

}

